import { useParams, Link } from "react-router-dom";
import blogData from "../data/blogData";
import SEO from "./SEO";
import { orgSchema, blogPostingSchema } from "../utils/structuredData";

const TaxNewsArticle = () => {
  const { id } = useParams();
  const blog = blogData.find((b) => b.id === id);

  if (!blog) return <p>Blog not found.</p>;

  // Function to parse text with custom styles
  const parseText = (text) => {
    let parsed = text;

    // Convert ## to <h2>
    parsed = parsed.replace(/##\s*(.*?)\n/g, "<h2>$1</h2>");

    // Convert ### to <h3>
    parsed = parsed.replace(/###\s*(.*?)\n/g, "<h3>$1</h3>");

    // Convert unordered lists: lines starting with *
    parsed = parsed.replace(/(?:^|\n)\*(.*?)\n/g, "<li>$1</li>");
    parsed = parsed.replace(/<li>(.*?)<\/li>(?!<li>)/g, "<ul>$&</ul>");

    // Convert links [text](url)
    parsed = parsed.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Convert bold text **text**
    parsed = parsed.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    // Convert italic text _text_ or *text*
    parsed = parsed.replace(/(?:\_|\*)(.*?)\1/g, "<em>$1</em>");

    // Wrap text in paragraphs for content separated by double new lines
    parsed = parsed.replace(/\n\n/g, "</p><p>");
    parsed = `<p>${parsed}</p>`;

    return parsed;
  };

  return (
    <div className="tax-news-detail">
      <SEO
        title={`${blog.contentTitle} | Tax Advocate Group`}
        description={blog.teaser}
        canonical={`/tax-news/${blog.id}`}
        structuredData={[orgSchema, blogPostingSchema(blog)]}
      />
      {/* Hero with overlay */}
      <header
        className="tax-news-hero"
        style={{ backgroundImage: `url("/images/hero-19.png")` }}
      >
        <div className="tax-news-overlay"></div>
        <div className="tax-news-content">
          <h1>{blog.contentTitle}</h1>
          <nav className="tax-news-breadcrumbs">
            <Link to="/">Home</Link> <span>/</span>
            <Link to="/tax-news">Tax News</Link> <span>/</span>
            <span>{blog.title}</span>
          </nav>
        </div>
      </header>

      {/* Blog Content */}
      <div className="dynamic-article">
        <div className="dynamic-article-header">
          <div className="dynamic-article-accent-line"></div>
          <h2>{blog.contentTitle}</h2>
        </div>
        {blog.contentBody.map((paragraph, index) => (
          <div
            key={index}
            dangerouslySetInnerHTML={{ __html: parseText(paragraph) }}
          />
        ))}
      </div>
    </div>
  );
};

export default TaxNewsArticle;
